export default function PrivacyPolicy() {
  return (
    <main style={{ maxWidth: 720, margin: '0 auto', padding: '2rem' }}>
      <h1>Privacy Policy</h1>
      <p>This page is a placeholder. Add the full Privacy Policy content here later.</p>
    </main>
  );
}